module.exports = __webpack_public_path__ + "img/co_wrapbg5.417b03c6.png";